import React, { createContext, useContext, useEffect, useState } from 'react'

import { ClosestScrollableParentProviderProps } from './types'

const ClosestScrollableParentContext = createContext<HTMLElement | null>(null)

export const ClosestScrollableParentProvider: React.FC<
  ClosestScrollableParentProviderProps
> = ({ tableRef, children }) => {
  const [closestScrollableParent, setClosestScrollableParent] =
    useState<HTMLElement | null>(null)

  // Detect closest scrollable parent and set onScroll event to detect when it reaches the bottom
  useEffect(() => {
    if (tableRef.current) {
      const closestScrollableParent = findClosestScrollableParent(
        tableRef.current,
      )
      setClosestScrollableParent(closestScrollableParent)
    }

    return () => {}
  }, [tableRef])

  return (
    <ClosestScrollableParentContext.Provider value={closestScrollableParent}>
      {children}
    </ClosestScrollableParentContext.Provider>
  )
}

// Custom hook to use the context
export const useClosestScrollableParent = () => {
  return useContext(ClosestScrollableParentContext)
}

export function isElementBody(element: HTMLElement | null) {
  if (typeof window === 'undefined') return false
  return element === document.body || element === document.documentElement
}

// Utility function to find the closest scrollable parent
function findClosestScrollableParent(
  element: HTMLElement | null,
): HTMLElement | null {
  if (typeof window === 'undefined' || !element) {
    return null
  }

  let parent: HTMLElement | null = element.parentElement

  while (parent && parent !== document.body) {
    const overflowY = window.getComputedStyle(parent).overflowY
    if (overflowY === 'auto' || overflowY === 'scroll') {
      return parent
    }
    parent = parent.parentElement
  }

  return document.body
}
